import React, { useEffect } from 'react'
import { Typography, Button } from '@weirgroup/weir-dls'
import { useTranslation } from 'react-i18next'
import { CustomCheckbox } from '../../../../components/checkbox'
import './template-step.scss'
import { useAnalyticsEvent } from '../../../../hooks/useAnalyticsEvent'

interface TemplateStepProps {
    darkMode: boolean
    isAcknowledged: boolean
    onCheckboxChange: (checked: boolean) => void
    onNext: () => void
    onDownloadTemplate: () => void
}

export const TemplateStep: React.FC<TemplateStepProps> = ({
    darkMode,
    isAcknowledged,
    onCheckboxChange,
    onNext,
    onDownloadTemplate
}) => {
    const { t } = useTranslation()
    const logAnalyticsEvent = useAnalyticsEvent();
    useEffect(() => {
        logAnalyticsEvent('user_viewed_template_step', { description: 'User viewed the template step in upload assets' });
    },[]);
    return (
        <div className="template-step">
            <Typography
                variant="P1"
                color={darkMode ? "white" : "black"}
                className="step-instruction"
            >
                {t('uploadAssets.instructions.downloadTemplate')}
            </Typography>
            <div className='spacing'></div>
            <Button
                darkMode={darkMode}
                label={t('uploadAssets.buttons.downloadTemplate')}
                size="md"
                variant="secondary"
                onClick={onDownloadTemplate}
            />
            <Typography
                variant="P1"
                color={darkMode ? "white" : "black"}
                className="step-instruction"
            >
                {t('uploadAssets.instructions.gatherInformation')}
            </Typography>
            <Typography
                variant="P1"
                color={darkMode ? "white" : "black"}
                className="step-instruction"
            >
                {t('uploadAssets.instructions.uploadFile')}
            </Typography>
           <div className={`notes-section ${darkMode ? 'dark-mode' : ''}`}>
                <p>
                    <strong>{t('notes')}:</strong> {t('uploadAssets.note')}
                </p>
            </div>
            <div className="acknowledgment-section">
                <CustomCheckbox
                    darkMode={darkMode}
                    label={t('uploadAssets.checkbox.acknowledgeAndProceed')}
                    checked={isAcknowledged}
                    onChange={onCheckboxChange}
                />
            </div>

            <div className="next-button-section">
                <Button
                    darkMode={darkMode}
                    label={t('uploadAssets.buttons.next')}
                    size="md"
                    variant="primary"
                    onClick={onNext}
                    disabled={!isAcknowledged}
                />
            </div>
        </div>
    )
}
